// client/src/components/landing/RoleValueSection.js
// "어떤 입장에서 보시겠어요?" — 역할 토글 밸류 섹션 (v6 B안 확정)
// 콘텐츠는 서비스 가이드 검증 사실만 사용.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function RoleValueSection() {
  const nav = useNavigate();
  const [role, setRole] = useState('mkt');

  return (
    <section className="lnd-sec lnd-wrap" style={{ paddingTop: 36 }}>
      <div className="lnd-sec__head">
        <h2>어떤 입장에서 보시겠어요?</h2>
      </div>
      <div className="roleswitch">
        <button
          type="button"
          className={`is-mkt${role === 'mkt' ? ' is-active' : ''}`}
          onClick={() => setRole('mkt')}
        >
          광고주예요
        </button>
        <button
          type="button"
          className={`is-inf${role === 'inf' ? ' is-active' : ''}`}
          onClick={() => setRole('inf')}
        >
          인플루언서예요
        </button>
      </div>

      <div className={`rolepane rolepane--mkt${role === 'mkt' ? ' is-on' : ''}`}>
        <div className="value3">
          <div className="v"><i>🎯</i><b>필요한 만큼만 모집</b><span>3명당 5,000원 수수료로 원하는 규모만큼 — 지원자 중에서 직접 골라요</span></div>
          <div className="v"><i>✅</i><b>결과 보고 지급</b><span>결과물을 검수하고 승인할 때 보상이 나가요 · 7일 미검수 시 자동 승인</span></div>
          <div className="v"><i>↩️</i><b>예산 손실 없음</b><span>보증금은 등록 시 차감되지만, 사용하지 않은 예산은 완료 시 자동 환원돼요</span></div>
        </div>
        <div className="rolecta">
          <button type="button" className="lnd-btn lnd-btn--blue lnd-btn--lg" onClick={() => nav('/marketer/register')}>
            광고주로 시작하기
          </button>
        </div>
      </div>

      <div className={`rolepane rolepane--inf${role === 'inf' ? ' is-on' : ''}`}>
        <div className="value3">
          <div className="v"><i>🛍️</i><b>고르는 건 나</b><span>보상·CPS·마감이 카드에 다 보여요 — 마음에 드는 프로젝트에만 지원</span></div>
          <div className="v"><i>📈</i><b>진행 상황이 한눈에</b><span>지원→선정→계약→제출→검수→지급, 6단계가 화면에 그대로 보여요</span></div>
          <div className="v"><i>💸</i><b>포인트는 현금으로</b><span>최소 5,000P부터 환전 — 90% 지급, 영업일 1~3일 안에 통장 입금</span></div>
        </div>
        <div className="rolecta">
          <button type="button" className="lnd-btn lnd-btn--mint lnd-btn--lg" onClick={() => nav('/influencer/register')}>
            인플루언서로 시작하기
          </button>
        </div>
      </div>
    </section>
  );
}

export default RoleValueSection;
